export default {"src":"/_next/static/media/CircleAIIcon.9cf8652a.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};